import moment from "moment";
import { Cell } from "../Cell";
import { ApplicantOrInvitee } from "../../types";

interface ApplicationSubmittedCellProps {
  applicant: ApplicantOrInvitee;
}

export const ApplicationSubmittedCell = ({
  applicant
}: ApplicationSubmittedCellProps) => {
  const isApplicant = "verifications" in applicant;

  return (
    <Cell isFirst isDataCell className="text-content-400">
      {isApplicant && applicant.application_submitted_at
        ? moment(applicant.application_submitted_at).format(
            "MMM DD, YYYY [at] h:mm A"
          )
        : "-"}
    </Cell>
  );
};
